var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }

  return cooked;
};

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

var __read = this && this.__read || function (o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o),
      r,
      ar = [],
      e;

  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) {
      ar.push(r.value);
    }
  } catch (error) {
    e = {
      error: error
    };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }

  return ar;
};

import React from 'react';
import styled, { css } from 'styled-components';
import { breakpoints, theme } from '@shapeable/theme';
import { classNames } from '../../utils/cn';
import { ContentReveal } from '../elements/content-reveal';
import { ContentNode } from './content-node';
var cls = classNames('content-node-reveal');
export var ContentNodeRevealDefaultProps = {}; // -------- Child Component Props -------->
// -------- Styles -------->

var ContainerStyles = breakpoints({
  base: css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  \n  "], ["\n  \n  "])))
});
var ContentNodeStyles = breakpoints({
  base: css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    padding: ", ";\n  "], ["\n    padding: ", ";\n  "])), theme.UNIT(4))
}); // -------- Components -------->

var My = {
  Container: styled(ContentReveal)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles),
  ContentNode: styled(ContentNode)(templateObject_4 || (templateObject_4 = __makeTemplateObject(["", ""], ["", ""])), ContentNodeStyles)
};
export var ContentNodeReveal = function ContentNodeReveal(props) {
  var className = props.className,
      children = props.children,
      entity = props.entity,
      rest = __rest(props, ["className", "children", "entity"]);

  var _a = __read(React.useState(false), 2),
      isExpanded = _a[0],
      setIsExpanded = _a[1];

  var onChange = function onChange() {
    setIsExpanded(!isExpanded);
  };

  console.log(entity);
  return React.createElement(My.Container, __assign({}, rest, {
    isExpanded: isExpanded,
    onChange: onChange,
    className: cls.name(className)
  }), React.createElement(My.ContentNode, {
    entity: entity
  }));
};
ContentNodeReveal.defaultProps = ContentNodeRevealDefaultProps;
ContentNodeReveal.cls = cls;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4;